var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 0L0 7.2h2.182v6.546h11.637V7.2H16L8 0zm0 1.957l4.364 3.928v6.406H3.637V5.885L8 1.957zM5.09 10.11V7.928h2.183v2.181H5.09z",
    fill: "#BB5366"
  })));
}
export default SvgHome;